import type {
	LeadFormWithQuestionProps,
	LeadFormWithQuestionStepFields,
} from "@component/assets/AbstractLeadForm/Steps/BasicLeadFormWithQuestion";
import { BasicLeadFormWithQuestion } from "@component/assets/AbstractLeadForm/Steps/BasicLeadFormWithQuestion";
import { faPhoneVolume as fasPhoneVolume } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormCity } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

interface Props extends LeadFormWithQuestionProps {
	withCallIcon?: boolean;
	withMortgage?: boolean;
}

export class LeadForm extends BasicLeadFormWithQuestion<LeadFormWithQuestionStepFields, Props> {
	protected renderCityField(): ReactNode {
		const { submitState, withMortgage } = this.props;

		return (
			<FormCity
				placeholder={withMortgage ? "Hol intéznéd a lakáshitelt?" : "Lakhely"}
				name="cityName"
				disabled={submitState !== undefined}
				required
			/>
		);
	}

	protected renderHeader(): ReactNode {
		const { withCallIcon } = this.props;

		if (withCallIcon) {
			return (
				<Card.Header>
					<div className="d-flex align-items-center">
						<FontAwesomeIcon icon={fasPhoneVolume} className="text-gold mr-3" size="3x" />
						<div className="h4 mb-0 font-weight-bold">
							A lakástámogatások részleteit emailben elküldjük és szakértőnk hamarosan felhív!
						</div>
					</div>
				</Card.Header>
			);
		}

		return super.renderHeader();
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
